import { createReducer } from 'redux-act';

const reducer = createReducer(
    {},
    window['$$_kxl_env']
);

export default reducer;


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/redux/reducers/env/reducer.ts